import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `%lang starknet

// Hints are the Cairo way to defer part of the program execution to an external program
// Memory can be accessed and assigned inside a hint by using variables identifiers.
// e.g., inside a hint variable 'a' is accessed through 'ids.a'

${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `func basic_hint() -> (value : felt) {
    alloc_locals;
    local res;
    // TODO: Insert hint here
    return (value=res);
}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_basic_hint{syscall_ptr : felt*}() {
    let (value) = basic_hint();
    assert 41 = value - 1;
    return ();
}`;
